import { QueryBuilderConfig } from 'ngx-angular-query-builder';
import { FilterFieldProvider } from './filter-field-provider';

export class QueryBuilderConfigProvider {


  constructor(private filterFieldProvider: FilterFieldProvider) {
  }

  setFilterFieldProvider(filterFieldProvider: FilterFieldProvider) {
    this.filterFieldProvider = filterFieldProvider;
  }

  getQueryBuilderConfig(): QueryBuilderConfig {

    const fields = this.filterFieldProvider.getFilterFields();
    let fieldObject = {};
    fields.forEach((field) => {
      let fieldName = this.filterFieldProvider.getFieldNameFromLabel(field.name);
      fieldObject[fieldName] = field;
    });

    let config: QueryBuilderConfig = {
      fields: fieldObject,
      getInputType: (field: string, operator: string) => {
        const obj = fieldObject[field];
        if (!obj) {
          console.error('Cant find field ' + field);
          return null;
        }
        const type = fieldObject[field].type;

        switch (operator) {
          case 'is null':
          case 'is not null':
            return null;  // No displayed component
          case 'between':
            if (type === 'number') return 'betweenNumber';
            else if (type === 'date') return 'betweenDate';
            else return null;
          case 'in':
          case 'not in':
            return 'multiselect';
          default:
            return type;
        }
      }
    };
    return config;

  }

}
